"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = install;
exports.hasPermission = void 0;
var _store = _interopRequireDefault(require("@/store"));
const hasPermission = exports.hasPermission = function resolveCode(codes) {
  if (!codes || !Array.isArray(codes)) {
    throw new Error(`缺少权限标识code！使用：v-permission="['edit']" ${codes}`);
  }
  const authCodes = _store.default.getters.authCodes;
  return codes.some(code => authCodes.includes(code));
};
function install(Vue) {
  Vue.directive('permission', {
    inserted(el, binding) {
      if (!hasPermission(binding.value)) {
        el.parentNode?.removeChild(el);
      }
    },
    update(el, binding) {
      if (!hasPermission(binding.value)) {
        el.parentNode?.removeChild(el);
      }
    }
  });
  Vue.prototype.$permission = hasPermission;
}